FAQSearchModel = require('../models/search')
FAQAutoCompleteItemView = require('./autocompleteItem')
Backbone = require 'backbone'
Backbone.$ = $
FAQAutoSuggestionListView = require('./autosuggestionlist')

class FAQAutoCompleteView extends Backbone.View
  tagName: "ul"
  className: "autocomplete"

  initialize: (options) ->
    @options = options || {}
    @wait = 500
    @searchModel = new FAQSearchModel()
    @container = @options.container
    @input = $("#searchFormInput")
    @input.focus()
    @numberOfSiblings = 1
    @currentText = null

  render : () ->
    @keyup = _.debounce(@keyup, @wait)
    $('#searchContent', @container).append(@el)
    @bindEvents()

  invalidate : () ->
    @reset()
    @input.val('')

  bindEvents : () ->
    @input.keyup( (event) =>
      @keyup(event)
      return true
    )
    @input.keydown( (event) =>
      @keydown(event)
      return true
    )
    $('#btn-search').on('click',() =>
      @onEnter()
      return true
    )

    $(document).on('click',(event) =>
      $target = $(event.target)
      autocomplete =$target.closest(".autocomplate-form")
      if autocomplete.length is 0 && @$el.is(":visible")
        @invalidate()
    )

  keydown: (event) ->
    switch event.keyCode
      when 38 then @move(-1) # down - arrow
      when 40 then @move(+1) # up -arrow
      when 13 then @onEnter() # enter
      when 27 then @invalidate() # esc
      else return true

  keyup: () ->
    keyword = @input.val()?.trim()
    return @reset() unless @isValid(keyword)
    return @getItems(keyword) if @isChanged(keyword)
    return true

  move: (position) ->
    current = @$el.children(".active")
    siblings = @$el.children(".siblings")
    if current?.length > 0 && siblings?.length > 0 && position?
      index = (Number(current.attr("index")) + position + @numberOfSiblings) % @numberOfSiblings
      if (siblings.eq(index).length)
        current.removeClass("active")
        siblings.eq(index).addClass("active")
        return false
    if siblings?.length > 0
      current?.removeClass("active")
      siblings.eq(0).addClass("active")
    return false

  onEnter: () ->
    activeLnk = @$el.children(".active")
    if activeLnk?.length > 0
      href = $('a', activeLnk).attr('href')
      Backbone.history.navigate("#{href}", {trigger: true, replace: true}) if href?.length > 0
    else
      keyword = @input.val()?.trim()
      if @isValid(keyword)
        href = encodeURIComponent(keyword)
        href = "#{FAQAutoSuggestionListView.VIEWNAME}#{window.ID_seperator}#{href}"
        Backbone.history.navigate("#{href}", {trigger: true, replace: true})
    return false

  reset: () ->
    @currentText = null
    @numberOfSiblings = 1
    @hide()
    return false

  isChanged: (keyword) ->
    return (@currentText is null) or (@currentText isnt keyword)

  isValid: (keyword) ->
    return  keyword? && keyword.length > 0

  hide: () ->
    @$el.empty()
    @$el.hide()
    @container.hide()

  show: () ->
    @container.show()
    @$el.show()

  getItems : (keyword) ->
    @searchModel.setUrl(keyword)
    @currentText = keyword
    @searchModel.fetch
      success: ( model, response, options ) =>
        stopTimer("t_fa")
        @renderItems(response)
      error: ( model, xhr, options )  =>
        stopTimer("t_fa")
        @reset()
    startTimer("t_fa")

  renderItems: (response) ->
    if @currentText is response?.query
      if response?.docs?.length > 0
        @reset()
        @currentText = response.query
        @numberOfSiblings = response.docs.length
        @show()
        _.each(response.docs, (item, index) =>
            autoCompleteItem = new FAQAutoCompleteItemView()
            hash =
              item : item
              keyword : @currentText
              index : index
            autoCompleteItem.render(hash)
            @$el.append(autoCompleteItem.el)
        )
      else
        @reset()

module.exports = FAQAutoCompleteView
